var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initials)?_c('div',[_c('div',{staticClass:"fe-w-m fe-h-m fe-rounded-pill fe-bg-primary-20 fe-text-sparkle-60 fe-flex fe-justify-center fe-items-center fe-text-body-xxs fe-border fe-border-primary-grey-40"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }